export const REPORT_TYPE = {
    Detail: 1,
    Rollup: 2,
    CrossDetail: 3,
    CrossRollup: 4,
    MultiInstance: 5
};
